import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { scrollToElement } from '../services/Scroll'

const defaults = {
    passthrough: false
}

export default class ScrollTo extends Component {
    constructor(element) {
        super(element, defaults)
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick);
    }

    destroy() {
        this.element.removeEventListener('click', ::this.handleClick);
    }

    handleClick(event) {
        let id = null

        if (this.element.getAttribute('href')) {
            id = this.element.getAttribute('href').substring(this.element.getAttribute('href').indexOf('#') + 1);
        } else {
            id = this.element.dataset.href
        }

        const target = document.getElementById(id)

        if (target) {
            if (!this.options.passthrough) {
                event.preventDefault()
            }

            scrollToElement(target, { offset: 0 })
            EventBus.emit('scrollTo:scroll', id)
        }
    }
}
